export const API_URL = process.env.REACT_APP_API_URL || "https://sequflowapi.sequspace.com/api/v1";

export const ENDPOINTS = {
    AUTH: {
        LOGIN: "/auth/login",
        REGISTER: "/auth/register",
    },
    TASKS: {
        BASE: "/tasks",
    },
};